import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from 'vuetify/lib/locale/ru'
import colors from 'vuetify/lib/util/colors'

export default function(components, icons = {}) {
  Vue.use(Vuetify, { components })

  return new Vuetify({
    icons: {
      iconfont: 'mdi',
      values: icons
    },
    lang: {
      locales: { ru },
      current: 'ru',
    },
    theme: {
      themes: {
        light: {
          //primary: '#13688c', //'#00529c',
          //primary: colors.teal.darken4,
          primary: '#2F80ED',
          //secondary: '#d9ecf5',
          secondary: colors.teal.lighten5,
          //accent: '#7ad2f7', //'#82B1FF',
          accent: '#2F80ED',
          error: '#F84040',
          info: '#5bc0de',
          success: '#5cb85c',
          warning: '#f0ad4e',
          //'primary--text': '#003F59'
        }
      },
      options: {
        customProperties: true,
      }
    }
  })
}
